<template>
    <div>
            <b-row class="justify-content-center">
                <b-col sm="12" lg="8" xl="7">
                    
                    <franchise-monitor-component :companyId="$store.state.currentUser.companyId"></franchise-monitor-component>
                    
                </b-col>

                <b-col sm="12" lg="4" xl="3">

                    <b-card class="text-center static-left">
                        <ComponentUser v-show="this.$store.state.currentUser.id" />
                        <div v-show="!this.$store.state.currentUser.id">
                            <button class="border-0 bg-transparent text-secondary" @click="$router.push({ path: '/pages/login' })"><i class="fa fa-user-o fa-lg text-secondary" title="Entrar no Sistema"></i> Entrar no Sistema</button>
                        
                        </div>
                    </b-card>
                    
                    <b-card class="text-center static-left">
                        <ComponentToday />
                    </b-card>
        
                    <b-card class="text-center static-left">
                        <ComponentCalendar />
                    </b-card>
               
                    <b-card class="card-accent-primary text-center static-left" header="Links Externos">
                        <ComponentExternalLinks />
                    </b-card>
                                        
               
                </b-col>

            </b-row>
    </div>
    
 </template>
 
 
 <script>
 
 import ComponentUser from '@/views/dash/ComponentUser';
 
 import ComponentToday from '@/views/dash/ComponentToday';
 import ComponentCalendar from '@/views/dash/ComponentCalendar';
 import ComponentWeather from '@/views/dash/ComponentWeather';
 import ComponentExternalLinks from '@/views/dash/ComponentExternalLinks';
 import ComponentInvesting from '@/views/dash/ComponentInvesting';
 import FranchiseMonitorComponent from './franchise/FranchiseMonitorComponent';
 
 export default {
     name: 'intranet',
     components: {
         ComponentUser,
         ComponentToday,
         ComponentCalendar,
         ComponentWeather,
         ComponentExternalLinks,
         ComponentInvesting,
         FranchiseMonitorComponent
     },
     data: function() {
         return {


         }
     },
     methods: {
     },
     mounted: function() {
        
      
        
     }
     
 }
 
 </script>
 
 <style scoped>

.static-left {
    min-width: 330px;
}



 </style>
 
